import type { SearchResult } from '../../../../common/types';

export interface SearchResultTalentPosition extends SearchResult {
	lastModifiedDate?: string;
	position?: {
		// TODO: add position schema
		id: string;
		fieldValues: Array<{
			fieldId: string;
			fieldValue:
				| {
						stringValue: string;
				  }
				| {
						numericValue: number;
						numericDisplayValue: number;
				  }
				| {
						booleanValue: boolean;
				  };
		}>;
		worker: {
			user: {
				picture: string;
				name: string;
			};
		};
	};
	__typename: 'SearchResultTalentPosition';
}

export type SearchTalentPartial = SearchResultTalentPosition;

export const isSearchResultTalentPositionPartial = (
	partial: SearchResult,
): partial is SearchResultTalentPosition => {
	return partial?.id?.includes('radar') && partial.__typename === 'SearchResultTalentPosition';
};

export const isSearchTalentPartial = (partial: SearchResult): partial is SearchTalentPartial => {
	return isSearchResultTalentPositionPartial(partial);
};
